/*
	Conditional
	For hiding / showing items on click
*/
var Conditional = {
};

Conditional.Init = function(container) {
	
	Conditional.InitConditial(container);	
	
	// HINT CLICKING (tablet support) v1.0
	$('div.field label', container).not('.disabled label').click(function () {
		$(this).siblings('input,textarea').focus();
	});	
};

Conditional.InitConditial = function(container) {
	
	// CONDITIONAL HIDDEN
	$('.hidden', container).hide();

	// CONDITIONAL SELECT (V1.0)
	$('.conditional select', container).change(function () {
		var selectedOption = $(this).children(":selected").attr('value');
		if (selectedOption == '') {
			return;
		}
		$('.hidden.' + selectedOption).show();
		$(this).find('option').not(':selected').each(function () {
			var notSelectedOption = $(this).attr('value');
			if (notSelectedOption == '') {
				return;
			}
			$('.hidden.' + notSelectedOption).hide();
		});
	}).trigger('change');
	
	/* Conditional Radios and Checkboxes touch fix*/
	$('.conditional.checks label, .conditional.radios label, .checks .conditional label, .radios .conditional label', container).on('click touchstart', function () {
		Conditional.ValidateConditionalChecksAndRadios();
		Conditional.ValidateTogglelist();
	});	
	Conditional.ValidateConditionalChecksAndRadios();	
	Conditional.ValidateTogglelist();	
};

Conditional.ValidateConditionalChecksAndRadios = function() {
	$('.conditional input').each(function () {
		var forValue = $(this).attr('id');
		
		if ($(this).is(':checked')) {
			$('.hidden.' + forValue).show();
		} else {
			$('.hidden.' + forValue).hide();
		}
	});
};

Conditional.ValidateTogglelist = function() {
	$('.togglelist-title input').each(function () {
		var forValue = $(this).attr('id');
		
		if ($(this).is(':checked')) {
			$(this).closest('.togglelist-item').addClass('togglelist-item-active');
		} else {
			$(this).closest('.togglelist-item').removeClass('togglelist-item-active');
		}
	});
};